<template>
  <div class="letter_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('user.setting') }}
      </div>
    </div>
    <van-cell
      is-link
      @click="$router.push('/language')"
    >
      <template #title>
        <van-icon
          name="list-switching"
          size="22"
          style="padding-right: 10px;"
        />
        <span class="custom-title">{{ $t('safe.language') }}</span>
      </template>
    </van-cell>
    <van-cell
      is-link
      @click="$router.push('/setpwd')"
    >
      <template #title>
        <van-icon
          name="lock"
          size="22"
          style="padding-right: 10px;"
        />
        <span class="custom-title">{{ $t('safe.signInPassword') }}</span>
      </template>
    </van-cell>
    <!-- <van-cell is-link @click="$router.push('/setpaypwd')">
		  <template #title>
			<van-icon name="shield-o" size="22" style="padding-right: 10px;"/>
		    <span class="custom-title">{{$t('safe.paymentPassword')}}</span>
		  </template>
		</van-cell> -->

    <van-cell>
      <template #title>
        <van-icon
          name="brush-o"
          size="22"
          style="padding-right: 10px;"
        />
        <span class="custom-title">{{ $t('feng.cache') }}</span>
      </template>
    </van-cell>
    <!-- 	<van-cell is-link >
		  <template #title>
			<van-icon name="warning-o" size="22" style="padding-right: 10px;"/>
		    <span class="custom-title">{{$t('index.aboutUs')}}</span>
		  </template>
		</van-cell>
		<van-cell is-link >
		  <template #title>
			<a v-if="app" :href="app.kefu_link" target="_blank" style="color: #000;">
				<van-icon name="chat" size="22" style="padding-right: 10px;"/>
				<span class="custom-title">{{$t('feng.back')}}</span>
			</a>
		  </template>
		</van-cell> -->
    <van-cell value=" V1.0.0 ">
      <template #title>
        <van-icon
          name="info-o"
          size="22"
          style="padding-right: 10px;"
        />
        <span class="custom-title">{{ $t('feng.version') }}</span>
      </template>
    </van-cell>
		
		
    <div style="margin: 3vw;">
      <div
        class="history_coupon flex_center basic_btn"
        @click="logout"
      >
        <span>{{ $t('safe.signOut') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
	import Fetch from '../../utils/fetch';

	export default {
		name: "Set",
		data() {
			return {
				title:"title_"+ (this.$i18n.locale||"zh_cn"),
				content:"content_"+ (this.$i18n.locale||"zh_cn"),
				app:null,
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
				});
			},
			logout() {
				localStorage.removeItem('token');
				this.$router.replace("/");
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		position: relative;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
		// background: linear-gradient(90deg, #5b60df, #5b60df) !important;
	}

	/* Scoped settings list styling. */
	.letter_wrap { min-height: 100vh; padding-bottom: calc(88px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); }
	.red_top_bg { height: 54px; background: rgba(255, 252, 245, .97); border-bottom: 1px solid rgba(190, 139, 52, .45); }.red_top_bg .big_tit, .red_top_bg .back_left { color: #873126; }
	/deep/ .van-cell { min-height: 62px; margin: 12px 14px 0; width: auto; border: 1px solid rgba(190, 139, 52, .46); border-radius: 13px; background: #fffdf8; color: #533126; box-shadow: 0 5px 14px rgba(125, 82, 35, .07); }.letter_wrap /deep/ .van-cell:after { display: none; }.letter_wrap /deep/ .van-cell__title, .letter_wrap /deep/ .van-cell__value { color: #533126; }.letter_wrap /deep/ .van-icon { color: #a6233d; }.letter_wrap /deep/ .van-cell__right-icon { color: #b9802e; }
	.letter_wrap /deep/ .van-cell { display: flex; align-items: center; padding-top: 0; padding-bottom: 0; }.letter_wrap /deep/ .van-cell__title { display: flex; align-items: center; min-height: 60px; }.letter_wrap /deep/ .van-cell__value { display: flex; align-items: center; justify-content: flex-end; }.letter_wrap /deep/ .van-cell__right-icon { align-self: center; margin-top: 0; line-height: 1; }.custom-title { display: inline-flex; align-items: center; min-height: 22px; line-height: 22px; }
	.history_coupon.basic_btn { height: 50px; border: 1px solid rgba(166, 35, 61, .42); border-radius: 12px; background: linear-gradient(105deg, #a6233d, #ca5a5b) !important; color: #fff8e8 !important; line-height: 48px; box-shadow: 0 9px 20px rgba(126, 28, 47, .2); }
	
</style>
